// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest } from '@/libs/axios';

// 分页获取消息信息
export const _getByPage = (params) => {
    return getRequest('/message/getByPage', params)
}